import { PersonaGender } from '../../lib/enums';

export const PERSONA_GENDER_OPTIONS: {
  value: PersonaGender;
  label: string;
}[] = [
  { value: PersonaGender.Male, label: 'Male' },
  { value: PersonaGender.Female, label: 'Female' },
  { value: PersonaGender.NonBinary, label: 'Non-binary' },
];
